import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import { UsersSelf } from '@freelancer/datastore/collections';
import { Margin } from '@freelancer/ui/margin';
import { PictureDisplay, PictureImage } from '@freelancer/ui/picture';
import { CreditCardTypeApi } from 'api-typings/payments/payments';
import * as Rx from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-credit-card-logos',
  template: `
    <fl-bit class="CreditCardLogoGroup" [flMarginBottom]="Margin.XXXSMALL">
      <ng-container *ngFor="let logo of creditCardLogos$ | flAsync">
        <fl-picture
          [alt]="logo.alt"
          [src]="logo.src"
          [boundedWidth]="true"
          [display]="PictureDisplay.BLOCK"
          [flMarginRight]="Margin.XXSMALL"
        ></fl-picture>
      </ng-container>
    </fl-bit>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./credit-card-logos.component.scss'],
})
export class CreditCardLogosComponent implements OnInit {
  PictureDisplay = PictureDisplay;
  Margin = Margin;

  @Input() userInfo$: Rx.Observable<UsersSelf>;

  creditCardLogos$: Rx.Observable<readonly PictureImage[]>;
  mainCreditCardLogos: readonly PictureImage[] = [
    {
      alt: 'visa logo',
      src: this.getCCLogoPath(CreditCardTypeApi.VISA),
    },
    {
      alt: 'master card logo',
      src: this.getCCLogoPath(CreditCardTypeApi.MASTERCARD),
    },
    {
      alt: 'amex logo',
      src: this.getCCLogoPath(CreditCardTypeApi.AMEX),
    },
    {
      alt: 'jcb logo',
      src: this.getCCLogoPath(CreditCardTypeApi.JCB),
    },
  ];

  mexicanCardLogos: readonly PictureImage[] = [
    {
      alt: 'carnet logo',
      src: this.getCCLogoPath(CreditCardTypeApi.CARNET),
    },
  ];

  brazilianCardLogos: readonly PictureImage[] = [
    {
      alt: 'hiper card logo',
      src: this.getCCLogoPath(CreditCardTypeApi.HIPERCARD),
    },
    {
      alt: 'elo logo',
      src: this.getCCLogoPath(CreditCardTypeApi.ELO),
    },
    {
      alt: 'aura logo',
      src: this.getCCLogoPath(CreditCardTypeApi.AURA),
    },
  ];

  ngOnInit() {
    this.creditCardLogos$ = this.userInfo$.pipe(
      map(userInfo => {
        if (userInfo.address) {
          if (userInfo.address.country === 'Brazil') {
            return [...this.mainCreditCardLogos, ...this.brazilianCardLogos];
          }
          if (userInfo.address.country === 'Mexico') {
            return [...this.mainCreditCardLogos, ...this.mexicanCardLogos];
          }
        }
        return this.mainCreditCardLogos;
      }),
    );
  }

  getCCLogoPath(method: CreditCardTypeApi) {
    return `payments/cc/${method}.svg`;
  }
}
